import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e267vpec48: FaireBrandEntity = {
  token: "b_e267vpec48",
  type: "brand",
  name: "Smiley Daze",
  avatarUrl:
    "https://cdn.faire.com/fastly/c75eb81eddf7e007c9351b38b98ec2946b8f27660094ae9ec711a86d4b9d47b9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a1a3cef79d9884d92377ed56ac37a9ee24279efc0e0debb24deac9e49c0ada0f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c75eb81eddf7e007c9351b38b98ec2946b8f27660094ae9ec711a86d4b9d47b9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a1a3cef79d9884d92377ed56ac37a9ee24279efc0e0debb24deac9e49c0ada0f.jpeg",
  location: "Hauppauge, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    "Smiley Daze is a sister owned business that was started in 2023. We are an affordable and stylish children's clothing brand.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:41.430Z",
    importedBy: "entity-db-cli",
  },
};
